import { type ApiHandlerContract, ApiService } from '@sparklayer-io/spark-dash-core/types/api';
import type { CustomerGroupIdentity } from '../types/customer-group.schema';
import { CustomerGroupSettingsApi, type CustomerGroupSettingsApiContract } from './settings.api';

export interface CustomerGroupApiContract {
  create(group: CustomerGroupIdentity): Promise<void>;
  update(group: CustomerGroupIdentity): Promise<void>;
  delete(): Promise<void>;
  settings(): CustomerGroupSettingsApiContract;
}

export class CustomerGroupApi extends ApiService implements CustomerGroupApiContract {
  constructor(
    api: ApiHandlerContract,
    private slug: string,
  ) {
    super(api);
  }

  public create(group: CustomerGroupIdentity): Promise<void> {
    return this.api.proxy({
      method: 'POST',
      path: '/v1/customer-groups',
      payload: {
        slug: this.slug,
        name: group.name,
        parent_slug: group.parent_slug,
      },
    });
  }

  public update(group: CustomerGroupIdentity): Promise<void> {
    return this.api.proxy({
      method: 'PATCH',
      path: '/v1/customer-groups/{slug}',
      params: { slug: this.slug },
      payload: {
        name: group.name,
        parent_slug: group.parent_slug,
      },
    });
  }

  public delete(): Promise<void> {
    return this.api.proxy({
      method: 'DELETE',
      path: '/v1/customer-groups/{slug}',
      params: { slug: this.slug },
    });
  }

  public settings(): CustomerGroupSettingsApiContract {
    return new CustomerGroupSettingsApi(this.api, this.slug);
  }
}
